module.exports = __webpack_public_path__ + "img/frame (29).42c68494.jpg";